<template>
  <div class="right">
    <div class="zhaopin">
      <h2><span>我的招聘</span></h2>
      <div class="xinzeng">
        <el-row>
          <el-col :span="1.5">
            <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table border height="500px" :data="MineRecruitList">
<!--          <el-table-column label="序号" prop="id" align="center"/>-->
          <el-table-column label="招聘公告标题" prop="title" align="center" width="100px" fixed/>
<!--          <el-table-column label="招聘公告内容" prop="content" align="center" width="200px"/>-->
<!--          <el-table-column label="手机端内容" prop="mobileContent" align="center" width="200px"/>-->
<!--          <el-table-column label="海报图片" prop="picUrl" align="center"/>-->
          <el-table-column label="类别" prop="category" align="center" width="100px"/>
<!--          <el-table-column label="数字" prop="postNum" align="center"/>-->
<!--          <el-table-column label="数字" prop="totalNumber" align="center"/>-->
          <!-- <el-table-column label="公告状态" prop="status" align="center" /> -->
          <el-table-column label="发布时间" prop="publishTime" align="center" width="100px"/>
<!--          <el-table-column label="删除标志" prop="delFlag" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <el-tag v-if="scope.row.delFlag == 0">存在</el-tag>-->
<!--              <el-tag type="danger" v-if="scope.row.delFlag == 2">删除</el-tag>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="是否开启报名" prop="open" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.open == 0">否</el-tag>
              <el-tag v-if="scope.row.open == 1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="开始时间" prop="startTime" align="center" width="100px"/>
          <el-table-column label="结束时间" prop="endTime" align="center" width="100px"/>
          <el-table-column label="是否展示" prop="pcShow" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.pcShow == 0">否</el-tag>
              <el-tag v-if="scope.row.pcShow == 1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否校验学信网" prop="checkXuexin" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.checkXuexin == 0">否</el-tag>
              <el-tag v-if="scope.row.checkXuexin == 1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否校验学历学位证明" prop="checkDegree" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.checkDegree == 0">否</el-tag>
              <el-tag v-if="scope.row.checkDegree == 1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否校验毕业证" prop="checkByz" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.checkByz == 0">否</el-tag>
              <el-tag v-if="scope.row.checkByz == 1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="个人诚信承诺书" prop="promise" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.promise == 0">否</el-tag>
              <el-tag v-if="scope.row.promise == 1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否校验职业资格证书" prop="qualificate" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.qualificate == 0">否</el-tag>
              <el-tag v-if="scope.row.qualificate == 1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否免费" prop="free" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.free == 0">否</el-tag>
              <el-tag v-if="scope.row.free == 1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="开始缴费日期" prop="startPay" align="center" width="120px"/>
          <el-table-column label="缴费截止日期" prop="endPay" align="center" width="120px"/>
          <el-table-column label="金额" prop="price" align="center" width="100px"/>
          <el-table-column label="审核状态" prop="auditStatus" align="center" fixed="right">
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.auditStatus == 0">未通过</el-tag>
              <el-tag type="success" v-if="scope.row.auditStatus == 1">通过</el-tag>
              <el-tag type="warning" v-if="scope.row.auditStatus == 2">待审核</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" align="center" width="150px" />
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdate(scope.row)"
                         :disabled="scope.row.delFlag == 2 || scope.row.auditStatus == 1 || scope.row.status == 1">修改</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)"
                         :disabled="scope.row.delFlag == 2 || scope.row.auditStatus == 2 || scope.row.auditStatus == 1 || scope.row.status == 1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="fenye" v-if="total > 0">
      <el-pagination @current-change="handleCurrentChange" background :total="total"
                     :page-size="10" :current-page.sync="pageNum">
      </el-pagination>
    </div>
    <!-- 添加或修改我的招聘对话框 -->
    <el-dialog :title="editTitle"  :visible.sync="open" width="1100px" append-to-body>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">招聘公告标题：</span>
          <input
            v-model="form.title"
            placeholder="请输入招聘公告标题"
            type="text"
            class="rczp-form-input"
          />
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">类别：</span>
            <select v-model="form.category" class="xialakuang">
              <option v-for="item in categoryList" :key="item.dictLabel" :label="item.dictLabel" :value="item.dictValue">
              </option>
            </select>
        </div>
      </div>

      <div class="rczp-row">
          <span class="rczp-form-label_editor">招聘公告内容：</span>
          <vue-ueditor-wrap 
                v-model="form.content"
                :config="myConfig"
              ></vue-ueditor-wrap>
      </div>

      <!-- <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">类别：</span>
            <select v-model="form.category" class="xialakuang">
              <option v-for="item in categoryList" :key="item.dictLabel" :label="item.dictLabel" :value="item.dictValue">
              </option>
            </select>
        </div>

        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">公告状态：</span>
          <select v-model="form.status" class="xialakuang">
            <option selected disabled label="请选择" hidden value=""></option>
            <option v-for="item in statusList" :key="item.dictLabel" :label="item.dictLabel" :value="item.dictValue">
            </option>
          </select>
        </div>
      </div> -->

      <div class="rczp-row">        
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">发布时间：</span>
          <input
            v-model="form.publishTime"
            placeholder="请选择发布时间"
            type="date"
            class="rczp-form-input"
          />
        </div>

        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">个人诚信承诺书：</span>
         <el-switch v-model="form.promise" class="drawer-switch" />
        </div>
      </div>

      <div class="rczp-row">
        
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">是否开启报名：</span>
          <el-switch v-model="form.open" class="drawer-switch" />
        </div>

        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">是否免费：</span>
          <el-switch v-model="form.free" class="drawer-switch" />
        </div>
      </div>

      <div class="rczp-row" v-if="form.open == true">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">开始时间：</span>
          <input
            v-model="form.startTime"
            placeholder="请输入"
            type="date"
            class="rczp-form-input"
          />
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">结束时间：</span>
          <input
            v-model="form.endTime"
            placeholder="请输入"
            type="date"
            class="rczp-form-input"
          />
        </div>
      </div>

      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">是否校验职业资格证书：</span>
          <el-switch v-model="form.qualificate" class="drawer-switch" />
        </div>

        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">是否校验毕业证：</span>
          <el-switch v-model="form.checkByz" class="drawer-switch" />
        </div>

      </div>

      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">是否校验学信网：</span>
          <el-switch v-model="form.checkXuexin" class="drawer-switch" />
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">是否校验学历学位证明：</span>
          <el-switch v-model="form.checkDegree" class="drawer-switch" />
        </div>
      </div>



      <div class="rczp-row" v-if="form.free == false">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">开始缴费日期：</span>
          <input
            v-model="form.startPay"
            placeholder="请输入"
            type="date"
            class="rczp-form-input"
          />
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">缴费截止日期：</span>
          <input
            v-model="form.endPay"
            placeholder="请输入"
            type="date"
            class="rczp-form-input"
          />
        </div>
      </div>

      <div class="rczp-row">
        <div class="rczp-col rczp-col-2" v-if="form.free == false">
          <span class="rczp-form-label">金额：</span>
          <input
            v-model="form.price"
            placeholder="请输入金额"
            type="number"
            :min="0"
            class="rczp-form-input"
          />
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">备注：</span>
          <input
            v-model="form.remark"
            placeholder="请填写备注"
            type="textarea"
            class="rczp-form-input"
          />
        </div>
      </div>

      <div slot="footer" class="dialog-footer" >
        <el-button type="primary" @click="submitForm(1)">提 交</el-button>
        <el-button type="primary" @click="submitForm(0)">存草稿</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { forEach } from 'shelljs/commands';
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: {
    VueUeditorWrap,
  },
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      userId:'',
      MineRecruitList: [],
      // 弹出层标题
      editTitle: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: null,
        content: null,
        mobileContent: null,
        picUrl: null,
        category: null,
        postNum: null,
        totalNumber: null,
        status: null,
        publishTime: null,
        open: null,
        free: null,
        pcShow: null,
        startTime: null,
        endTime: null,
        checkXuexin: null,
        checkDegree: null,
        checkByz: null,
        promise: null,
        qualificate: null,
        endPay: null,
        startPay: null,
        price: null,
        auditStatus: null,
        remark: null,
      },
      // 表单参数
      form: {},
      ifNoList: [
        { label: 0, value: "否" },
        { label: 1, value: "是" },
      ],
      dictValue: "",
      dictLabel:"",
      categoryList: [],
      statusList: [],
      myConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 180,
        wordCount: true,
        maximumWords: 100000,
        initialFrameWidth: "100%",
        // serverUrl: this.$file.uploadUpFile,
        // UEDITOR_HOME_URL: "/UEditor/",
        // toolbars: this.$common.editorConfig.toolbars,
      },
    };
  },
  activated() {
    this.getRecruitList();
  },
  methods: {

    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        title: null,
        content: null,
        mobileContent: null,
        picUrl: null,
        category: null,
        postNum: null,
        totalNumber: null,
        status: null,
        publishTime: null,
        delFlag: 0,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null,
        open: null,
        free: null,
        pcShow: null,
        startTime: null,
        endTime: null,
        checkXuexin: null,
        checkDegree: null,
        checkByz: null,
        promise: null,
        qualificate: null,
        endPay: null,
        startPay: null,
        price: null,
        auditStatus: 2,
      };
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getRecruitList();
    },
    async getRecruitList() {
      let _this = this;
      let data = {
        pageNum: _this.pageNum,
        pageSize: _this.pageSize,
        userId: _this.userId,
      };
      let res = await _this.$api.mineRecruit.getMineRecruitList(data);
      if (res.code == _this.$commons.RespCode.success) {        
        _this.MineRecruitList = res.rows;
        _this.total = Number(res.total);
        this.getCategoryList();
        this.getStatusList();
      }else {
        _this.$layerMsg.error(res.mag)
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.editTitle = "添加我的招聘";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      const id = row.id || this.ids
      this.$api.mineRecruit.getMineRecruit({id:id}).then(response => {
        this.form = response.data;        
        if (this.form.free == 0) {
          this.form.free = false;
        }else{
          this.form.free = true;
        }
        if (this.form.open == 0) {
          this.form.open = false;
        }else{
          this.form.open = true;
        }
        if (this.form.promise  == 0) {
          this.form.promise  = false;
        }else{
          this.form.promise  = true;
        }
        if (this.form.qualificate  == 0) {
          this.form.qualificate  = false;
        }else{
          this.form.qualificate  = true;
        }
        if (this.form.checkByz  == 0) {
          this.form.checkByz  = false;
        }else{
          this.form.checkByz  = true;
        }
        if (this.form.checkXuexin  == 0) {
          this.form.checkXuexin  = false;
        }else{
          this.form.checkXuexin  = true;
        }
        if (this.form.checkDegree  == 0) {
          this.form.checkDegree  = false;
        }else{
          this.form.checkDegree  = true;
        }
        this.form.auditStatus = 2;
        this.open = true;
        this.editTitle = "修改我的招聘";
      });
    },
    /** 提交按钮 */
    submitForm(e) {
      console.log("tijiao",e)
      if(e==0){
        this.form.status = 0
      }else if(e==1){
        this.form.status = 1
      }
      if (!this.form.title) {
        this.$layer.alert("请输入招聘公告标题!");
        return;
      }
      if (!this.form.content) {
        this.$layer.alert("请输入招聘公告内容!");
        return;
      }
      if(!this.form.category){
        this.$layer.alert("请选择类别！")
        return;
      }
      // if(!this.form.status){
      //   this.$layer.alert("请选择公告状态！")
      //   return;
      // }
      if(!this.form.publishTime){
        this.$layer.alert("请选择发布时间！")
        return;
      }
      if (!this.form.startTime && this.form.open == true) {
        this.$layer.alert("请选择开始时间!");
        return;
      }
      if (!this.form.endTime && this.form.open == true) {
        this.$layer.alert("请选择结束时间!");
        return;
      }
      if (!this.form.startPay && this.form.free == false) {
        this.$layer.alert("请选择开始缴费时间!");
        return;
      }
      if (!this.form.endPay && this.form.free == false) {
        this.$layer.alert("请选择缴费截止日期!");
        return;
      }
      if(!this.form.price && this.form.free == false){
        this.$layer.alert("请输入金额!")
        return;
      }else if (this.form.price < 0){
        this.$layer.alert("金额不能为负数！")
        return;
      }
      if (this.form.startTime > this.form.startPay){
        this.$layer.alert("开始缴费日期不能小于开始报名时间！")
        return;
      }
      if(this.form.endTime < this.form.endPay){
        this.$layer.alert("报名结束时间不能小于缴费截止日期！")
        return;
      }
      if(this.form.publishTime > this.form.startTime){
        this.$layer.alert("发布时间不能大于报名开始时间！")
        return;
      }
      if (this.form.startTime != null && this.form.endTime != null && this.form.startTime > this.form.endTime){
        this.$modal.msgError("开始时间不能大于结束时间")
        return;
      }
      if(this.form.startPay != null && this.form.endPay != null && this.form.startPay > this.form.endPay){
        this.$modal.msgError("开始缴费日期不能大于缴费截止日期")
        return;
      }
      if(this.form.free == false){
          this.form.free = 0
      }else{
         this.form.free = 1
      }
      if(this.form.promise == false){
          this.form.promise = 0
      }else{
         this.form.promise = 1
      }
      if(this.form.open == false){
          this.form.open = 0
      }else{
         this.form.open = 1
      }
      if(this.form.qualificate == false){
          this.form.qualificate = 0
      }else{
         this.form.qualificate = 1
      }
      if(this.form.checkByz == false){
          this.form.checkByz = 0
      }else{
         this.form.checkByz = 1
      }
      if(this.form.checkXuexin == false){
          this.form.checkXuexin = 0
      }else{
         this.form.checkXuexin = 1
      }
      if(this.form.checkDegree == false){
          this.form.checkDegree = 0
      }else{
         this.form.checkDegree = 1
      }
      if (this.form.id != null) {
        console.log("修改实体this.form",this.form)
        this.$api.mineRecruit.MineRecruitEdit(this.form).then(response => {
          this.$modal.msgSuccess("修改成功");
          this.open = false;
          this.getRecruitList();
        });
      } else {
        console.log("this.form",this.form)
        this.$api.mineRecruit.MineRecruitAdd(this.form).then(response => {
          this.$modal.msgSuccess("新增成功");
          this.open = false;
          this.getRecruitList();
        });
      }
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      let _this = this;
      const id = row.id;
      _this.$modal.confirm('是否确认删除题目编号为"' + id + '"的数据项？')
        .then(function () {
          return _this.$api.mineRecruit.MineRecruitDel({id:id});
        })
        .then(() => {
          _this.getRecruitList();
          _this.$modal.msgSuccess("删除成功");
        })
        .catch(() => {
        });
    },
    /** 查询类别 */
    getCategoryList() {
      let _this = this;
      let param = {
        dictType: 're_notice_category',
      };
      _this.$api.system.getDicByCode(param).then((res) => {
        if (res.code == _this.$commons.RespCode.success) {
          _this.categoryList = res.data;
        }
      })
        .catch(() => {
        });
    },
    /** 查询公告状态 */
    getStatusList() {
      let _this = this;
      let param = {
        dictType: 're_notice_status',
      };
      _this.$api.system.getDicByCode(param).then((res) => {
        if (res.code == _this.$commons.RespCode.success) {
          _this.statusList = res.data;
        }
      })
        .catch(() => {
        });
    },
  },
};
</script>
<style>
  .xinzeng{
    margin-bottom: 10px;
  }
  .rczp-col-2{
    margin-left: 20px;
    margin-right: 25px;
  }
  .rczp-form-label_editor {
    font-size: 16px;
    flex-shrink: 0;
    width: 20%;
    text-align: right;
  }
  .rczp-form-label{
    font-size: 16px;
    flex-shrink: 0;
    width: 40%;
    text-align: right;
  }
  .rczp-form-input{
    width: 300px;
    height: 40px;
  }
  .xialakuang{
    width: 300px;
    height: 35px;
    border-radius: 3px;
  }
 .drawer-switch {
    float: right
 }
</style>



// WEBPACK FOOTER //
// src/view/mine/mineRecruit.vue